import(/* webpackMode: "eager" */ "/www/wwwroot/dmt-courtbook/src/app/page.tsx");
